import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

import randomstring from 'uuid/v4';

class LaunchByHand extends React.Component {
    state = {
        local: undefined,
        family: this.props.family,
        process: undefined,
        loading: false,
    };

    static getDerivedStateFromProps(props, state) {
        if (props && props.locals && props.locals !== state.locals) {
            const permits = props.info.security.localPermits;

            const enabled = Object.keys(permits).reduce((arr, key) => {
                const p = permits[key];
                if (p.some((value) => value === '20' || value === '66')) {
                    arr.push(key);
                }
                return arr;
            }, []);
            const nodes = props.locals.reduce((arr, l) => {
                if (l.configurado === 3 && enabled.some((e) => e === l.id.toString())) {
                    arr.push(l);
                }
                return arr;
            }, []);
            state.locals = props.locals;
            state.nodes = nodes;
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = () => (event) => {
        this.props.onClose();
    };

    handleSummit = () => (event) => {
        this.setState({ loading: true });
        const { local } = this.state;
        this.props
            .postForecast(local)
            .then((r) => {
                console.log(r);
                if (r.error) {
                    this.props.onError(r.error.message);
                } else if (r && r.codigo) {
                    this.props.history.push(`/xef/forecast/${r.codigo}`);
                } else {
                    this.props.onClose(true);
                }
            })
            .catch((error) => this.props.onError(error.message));
    };

    render() {
        const { nodes, local } = this.state;
        const { intl } = this.props;
        console.log(nodes);
        return (
            <Dialog
                open={true}
                onClose={this.handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="simple-dialog-title">
                    <FormattedMessage id="LaunchByHand" />
                </DialogTitle>
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((cat) => {
                                            return (
                                                <option key={randomstring()} value={cat.id}>
                                                    {cat.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose()} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        disabled={!local}
                        onClick={this.handleSummit()}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

LaunchByHand.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(LaunchByHand);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecasts/LaunchByHand.js